import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-connect-ad-account',
  templateUrl: './connect-ad-account.component.html',
  styleUrls: ['./connect-ad-account.component.css']
})
export class ConnectAdAccountComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConnectAdAccountComponent>, ) { }

  ngOnInit(): void {
  }

  select(id) {
    console.log(id);
  }

  close() {
this.dialogRef.close(false);
  }

}
